// extracted by mini-css-extract-plugin
export var disable = "Pagination-module--disable--4zAQA";
export var next = "Pagination-module--next--PX9hj";
export var nextLink = "Pagination-module--nextLink--DTlD5";
export var pagination = "Pagination-module--pagination--3KtNE";
export var previous = "Pagination-module--previous--3Jp_8";
export var previousLink = "Pagination-module--previousLink--1mLDH";